import { TutorialsState } from '@layout/tutorials/store/states/tutorials.state';

export const videoTutorialsState = [TutorialsState];
